import { FiInfo as Info } from 'react-icons/fi';
import { TbSparkles as Sparkles } from 'react-icons/tb';
import SubtleBadge from '@/components/common/SubtleBadge';
import { periods } from '../pricing';
import { ui } from '../constants';
import type { PeriodDays } from '../types';

interface PeriodSelectorProps {
  value: PeriodDays;
  onChange: (days: PeriodDays) => void;
  disabled: boolean;
  restrictionLabel: string;
  walletTopUpEnabled: boolean;
}

function PeriodSelector({
  value,
  onChange,
  disabled,
  restrictionLabel,
  walletTopUpEnabled,
}: PeriodSelectorProps) {
  return (
    <div className="stage-group">
      <div className="stage-heading">
        <span className="eyebrow fs--2">{ui.stages.period.eyebrow}</span>
        <h2 className="text-1000">{ui.stages.period.title}</h2>
      </div>

      <div className="period-wrap rounded-4 bg-white dark__bg-card-dark">
        {disabled || walletTopUpEnabled ? (
          <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
            {disabled ? (
              <SubtleBadge bg="warning" className="fs--2 fw-normal">
                <span className="d-inline-flex align-items-center gap-1 py-1">
                  <Info size={14} />
                  {ui.stages.period.restrictionTemplate.replace(
                    '{label}',
                    restrictionLabel,
                  )}
                </span>
              </SubtleBadge>
            ) : null}
            {walletTopUpEnabled ? (
              <SubtleBadge bg="info" className="fs--2 fw-normal">
                <span className="d-inline-flex align-items-center gap-1 py-1">
                  <Sparkles size={14} />
                  {ui.stages.period.walletNote}
                </span>
              </SubtleBadge>
            ) : null}
          </div>
        ) : null}

        <div className={`period-selector rounded-3 ${disabled ? 'is-disabled' : ''}`}>
          {periods.map((period) => (
            <button
              type="button"
              key={period.months}
              className={value === period.months ? 'active rounded-3 text-900' : 'rounded-3 text-secondary'}
              onClick={() => onChange(period.months as PeriodDays)}
              disabled={disabled && period.months !== 30}
            >
              <span>{period.label}</span>
              <small className="rounded-1 text-secondary">{period.benefit}</small>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PeriodSelector;
